<template>
  <div>
    <section v-html="decodedContent"></section>
  </div>
</template>

<script>

export default {
  name: 'proposal',
  props: ['id'],
  data () {
    return {
      proposal: {}
    }
  },
  computed: {
    API() {
      return process.env.NODE_ENV === 'production' ? 'https://www.top-link.com.tw/' : 'https://apitest.top-link.com.tw/'
    },
    decodedContent() {
      return this.proposal.content ? this.decodeHtml(this.proposal.content) : '';
    }
  },
  created(){
    this.fetchProposalData();
  },
  methods: {
    fetchProposalData() {
      const proposal_api = `${this.API}api/tlweb/proposal/${this.$route.params.id}`;
      // const proposal_api = `${this.API}tlweb/proposal/${this.$route.params.id}`; // 測試用
      this.axios.get(proposal_api)
        .then((res) => {
          if (res.status === 200) {
            this.proposal = res.data.data;
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            window.location.href = 'https://www.top-link.com.tw/';
          } else {
            console.error(error);
          }
        });
    },
    decodeHtml(html) {
      console.log(html)
      console.log(this.proposal.content)
      const txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    }
  }
}
</script>

<style>
</style>
